
































import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import { encode } from "@common/util/base64Util";

export default Vue.extend({
  data() {
    const that = this as any;
    return {
      cpoGroupId: null,
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "_id",
          "sort-desc": false,
        },
        content: {
          name: "Cashback Partners",
          urlEnabled: true,
          search: {
            ext: {
              hidden: true,
            },
          },
          filters: {
            filters: {},
          },
          displayFields: {
            cpoGroup: {
              text: "Partner",
              options: {
                subProp: "tenant.name",
                transform: (value) => {
                  return value || "N/A";
                },
                to: (_value, row) => {
                  const ocpiModeMeta = that.$route?.meta?.ocpiMode;
                  const base = ocpiModeMeta === "roaming_in"
                      ? "cashback_roaming_in_partner/"
                      : ocpiModeMeta === "roaming_out"
                        ? "cashback_roaming_out_partner/"
                        : "cashback_partner/";
                  const filtersOrganization = {
                    "customPerPage": 0,
                    "dataOptions": {
                      "groupBy": [],
                      "groupDesc": [],
                      "itemsPerPage": 50,
                      "multiSort": false,
                      "mustSort": false,
                      "page": 1,
                      "sortBy": [
                        "cpoGroup.name"
                      ],
                      "sortDesc": [
                        false
                      ]
                    },
                    "filters": [
                      {
                        "key": "point",
                        "operator": "greater_than",
                        "value": 0
                      }
                    ]
                  };
                  return base + row._id + '?table_options=' + encode(JSON.stringify(filtersOrganization));
                },
              },
            },
            powerConsumption: {
              text: "Power Consumption (kWh)",
              sortable: true,
            },
            electricityTariff: {
              text: "Electricity Tariff",
              sortable: true,
            },
            powerCost: {
              text: "Power Cost (VND)",
              sortable: true,
            },
            totalPoints: {
              text: "Revenue (VND)",
              sortable: true,
            },
            netRevenue: {
              text: "Net Revenue (VND)",
              sortable: true,
            },
            ratio: {
              text: "Ratio",
              sortable: true,
            },
            partnerRevenue: {
              text: "Partner Revenue (VND)",
              sortable: true,
            },
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              // For local cashback (default route), use 'local' as ocpiMode
              // For roaming routes, use the meta ocpiMode
              let ocpiModeMeta = that.$route?.meta?.ocpiMode as string | undefined;
              if (!ocpiModeMeta) {
                ocpiModeMeta = 'local'; // Default to 'local' for the main cashback route
              }
              console.log('CashbackGroup findAll - ocpiMode:', ocpiModeMeta, 'route:', that.$route?.path);

              const apiOptions = { ...(options || {}) };
              // Always add ocpiMode parameter
              apiOptions.ocpiMode = ocpiModeMeta;
              console.log('CashbackGroup findAll - apiOptions with ocpiMode:', apiOptions);

              const { items, count } = await coreApiClient.call("cashBacks", "groupStatics", apiOptions);
              return [items, count];
            },
          },
          dataOptions: {
            itemsPerPage: 50,
            page: 1,
            multiSort: false,
            mustSort: false,
            groupBy: [],
            groupDesc: []
          },
        },
      },
    };
  },
});

